export default {
  title: 'Descuento por contrato anual',
  buttons: {
    edit: 'Editar descuento',
    save: 'Guardar descuento',
  },
  toasts: {
    invalid_discount: 'El descuento anual debe estar entre {{min}}% y {{max}}%',
  },
};
